import type { TensionRule } from '../../data/schemas';
import type { SeverityId } from '../../types/ids';
import type { DetectedTension, EvaluationContext } from '../../types/result';
import { evaluateConditionGroup } from './evaluateRuleCondition';

const severityRank: Record<SeverityId, number> = {
  notice: 0,
  important: 1,
  critical: 2,
};

/**
 * Erkennt zutreffende Spannungsfeld-Regeln und sortiert sie nach Priorität, dann Schweregrad (Abschnitt 17.4).
 * Verändert niemals den Gesamt-Score (AC-009).
 */
export function detectTensions(
  context: EvaluationContext,
  tensionRules: readonly TensionRule[],
): DetectedTension[] {
  const seen = new Set<string>();
  const detected: DetectedTension[] = [];

  for (const rule of tensionRules) {
    if (seen.has(rule.id)) continue;
    const matches = evaluateConditionGroup(rule.conditions, rule.conditionMode, context);
    if (!matches) continue;
    seen.add(rule.id);
    detected.push({
      ruleId: rule.id,
      title: rule.title,
      shortLabel: rule.shortLabel,
      severity: rule.severity,
      priority: rule.priority,
      summary: rule.summary,
      explanation: rule.explanation,
      businessImpact: rule.businessImpact,
      personalImpact: rule.personalImpact,
      recommendationIds: rule.recommendationIds,
    });
  }

  detected.sort((a, b) => {
    if (b.priority !== a.priority) return b.priority - a.priority;
    return severityRank[b.severity] - severityRank[a.severity];
  });

  return detected;
}
